// src/tours/tourSteps.js

// --- UPDATED TOUR FOR THE MAIN DASHBOARD ---
export const dashboardTourSteps = [
  {
    target: 'body',
    title: 'Welcome to Your Dashboard!',
    content: 'This is your command center for managing all your Ideal Candidate Profiles. Let\'s take a quick look around.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="new-profile-button"]',
    title: 'Create a New Profile',
    content: 'This is the most important first step. Click here to create an "Ideal Candidate Profile," which acts as the blueprint for your job opening.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar"]',
    title: 'Find Your Profiles',
    content: 'As your list grows, you can instantly find any profile by searching for its title here.',
    placement: 'bottom',
    disableBeacon: true,

  },
  {
    target: '[data-tour="quick-access"]',
    title: 'Quick Access',
    content: 'Your most recently viewed profiles will appear here for easy access.',
    placement: 'bottom',
    disableBeacon: true,

  },
  {
    target: '[data-tour="account-menu"]',
    title: 'Your Account & Settings',
    content: 'Click here to manage your personal info, organization settings, notification preferences, and more.',
    placement: 'bottom',
    disableBeacon: true,

  }
];

// Tour for the Passive Search page
export const passiveSearchTourSteps = [
    {
        target: 'body',
        title: 'Passive Candidate Search',
        content: 'This page allows you to find qualified candidates who may not be actively looking for a job, broadening your talent pool.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tour="search-textarea"]',
        title: 'Describe Your Ideal Candidate',
        content: 'Paste a full job description or enter key skills and requirements here. Our AI will analyze it to find the best matches.',
        placement: 'bottom',
    },
    {
        target: '[data-tour="find-candidates-button"]',
        title: 'Start the Search',
        content: 'Click here to begin the search. Results will appear in the table below, ranked by their match score.',
        placement: 'bottom',
    }
];

// Tour for the Settings page
export const settingsTourSteps = [
    {
        target: '[data-tour="settings-sidebar"]',
        title: 'Settings Menu',
        content: 'Use this menu to navigate between different settings sections.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '[data-tour="settings-personal-info"]',
        title: 'Personal Info',
        content: 'Here you can update your name, profile picture, and other personal details.',
        placement: 'right',
    },
    {
        target: '[data-tour="settings-organization"]',
        title: 'Organization',
        content: 'Manage your organization\'s name and invite or remove team members.',
        placement: 'right',
    }
];
